import type { FC } from 'react'

import { Check } from 'lucide-react'

import { PillButton } from '@/components/generals/pill-button'
import { BoardImage } from '@/components/generals/board-image'
import { studio, visitSection } from '@/constants/dentea'

/** Shared pre-footer location block. Appears on every page. */
export const VisitSection: FC = () => {
    return (
        <section id='visit-us' aria-labelledby='visit-heading' className='w-full bg-ink/6'>
            <div className='mx-auto flex w-full flex-col items-center gap-10 px-6 py-20 lg:min-h-screen lg:flex-row lg:gap-20 lg:px-20 lg:py-20'>
                <div className='flex w-full flex-col gap-6 lg:w-2/5'>
                    <div className='flex flex-col gap-6 md:gap-10'>
                        <h2
                            id='visit-heading'
                            data-anim='lines'
                            className='display display-italic text-[3rem] opacity-0 md:text-[4rem] lg:text-[6rem]'
                            style={{ letterSpacing: '-0.04em' }}
                        >
                            {visitSection.label}
                        </h2>

                        <p data-anim='rise' className='serif-body max-w-[320px] text-[1.1rem] md:text-[1.3rem]'>
                            {visitSection.headline}
                        </p>
                    </div>

                    <ul data-anim-group data-anim-stagger='0.06' data-anim-from='16' className='flex flex-col gap-1'>
                        {visitSection.amenities.map((item) => (
                            <li key={item} className='flex max-w-[352px] items-start gap-2'>
                                <Check aria-hidden='true' className='mt-px size-4 shrink-0 text-ink' strokeWidth={2} />
                                <span className='label text-ink/70'>{item}</span>
                            </li>
                        ))}
                    </ul>
                </div>

                <div className='flex w-full flex-col items-start gap-6 lg:flex-1 lg:items-end lg:gap-10'>
                    <div data-anim='mask' className='relative h-70 w-full overflow-hidden rounded-2xl bg-charcoal lg:h-[50vh]'>
                        <BoardImage data-anim-inner tile={studio.exterior} className='absolute inset-0 size-full' />
                    </div>

                    <div className='flex w-full flex-col items-start gap-6 sm:flex-row sm:items-center sm:justify-between'>
                        <p data-anim='rise' className='serif-body max-w-[260px] text-[1.1rem] md:text-[1.3rem]'>
                            {studio.addressInline}
                        </p>

                        <PillButton
                            href={visitSection.cta.href}
                            arrow='diagonal'
                            size='lg'
                            external
                            className='w-full justify-center sm:w-75'
                        >
                            {visitSection.cta.label}
                        </PillButton>
                    </div>
                </div>
            </div>
        </section>
    )
}
